export enum TimeFormat {
  /** Server date formats
   * (ServerFormatDateTime) Should be removed in the future!!!!! */
  ServerFormatDateTime = 'YYYY-MM-DD HH:mm', //hh - 12hours am/pm format, HH - 24hours format

  NaiveDateTimeString = 'YYYY-MM-DDTHH:mm:ss',
  /** Same naive wall-clock, without seconds - the backend emits/accepts both forms. */
  NaiveDateTimeStringNoSeconds = 'YYYY-MM-DDTHH:mm',

  Date = 'YYYY-MM-DD',
  DateTime = 'YYYY-MM-DD HH:mm',
  FullDateTime = 'YYYY-MM-DD HH:mm:ss',
  FullDateTimeMillis = 'YYYY-MM-DD HH:mm:ss.SSS',
  FullDateTimeNoYear = 'DD/MM HH:mm',
  FullDateTimeMonthName = 'yyyy MMM D, HH:mm',
  Time = 'HH:mm',
  FullTime = 'HH:mm:ss',
  PartialDate = 'DD.MM',

  /** Calendar date formats */
  CalendarDate = 'DD/MM/YYYY',
  CalendarDateNoYear = 'DD/MM',
  CalendarYearMonth = 'MMMM yyyy',
  CalendarDateMonthDay = 'MM/dd/yyyy',
  CalendarWeekDayMonthYear = 'ddd MMMM DD YYYY',

  ImportDataDate = 'MM/DD/YYYY',

  DotsDate = 'D.M.YYYY',
  MonthDayYear = 'MMM d yyyy, HH:mm',
  MonthDayYearOnly = 'MMM DD, yyyy',
  MonthNamedDateTime = 'MMM DD HH:mm',
  MonthName = 'MMMM',
}

export enum DatePickerFormats {
  Date = 'yyyy-MM-dd',
  MonthDayYearNoHour = 'MMM dd yyyy',
  MFormDate = 'MM/dd/yyy',
  MFormDateTime = 'yyy/MM/dd h:mm',
  MonthDayYear = 'MMM d yyyy, HH:mm',
  GeneralDayMonthYear = 'dd/M/yyyy HH:mm',
  Time = 'HH:mm',
  TimePicker = 'HH:mm',
  GeneralDatePicker = 'DD/MM/YYYY',
}
